import React, { useState } from 'react';
import useSqlDatabase from '../middleware/useSqlDatabase';
import controllerSql from '../controller/controller.upload';
import NavBar from './commonHooks/commonHooks.navBar';
import './css/upload.css';

const Upload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [message, setMessage] = useState('');
  const db = useSqlDatabase(selectedFile);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const parseDb = async () => {
    try {
      if (!selectedFile) {
        setMessage('No file selected');
        return;
      }

      if (await controllerSql(db)) {
        setMessage('Parse Successful');
        window.location.href = '/mylogs';
      }
    } catch (error) {
      setMessage("Some error occurred");
    }
  };

  const getUserData = () => {
    const userData = localStorage.getItem("user");
    return userData ? JSON.parse(userData) : null;
  };

  const userData = getUserData();

  return (
    <div className="upload-container">
      <NavBar />
      <div className="upload-content">
        <div className='upload-content-box'>
          <b>Upload the encounters.db file in your Loa Logs directory.</b> <br />
          <br />
          <b>1. In Loa Logs: </b> Settings &gt; Database &gt; Database Folder Open &gt; encounters.db 
        </div>
        {userData ? (
          <>
            <label htmlFor="file-upload" className="upload-button">Choose File</label>
            <input type="file" id="file-upload" onChange={handleFileChange} className="file-input" />
            <button className="parse-button" onClick={parseDb}>Parse DB</button>
            <div className="selected-file"> {selectedFile ? selectedFile.name : 'No file selected'} </div>
          </>
        ) : (
          <div className='upload-content-box'>
            <p>Must be signed in to parse data</p>
          </div>
        )}
        {message && <div className='upload-content-box'>
          <p>{message}</p>
        </div>}
      </div>
    </div>
  );
};

export default Upload;
